import { useSession } from "@packages/core-client/session/SessionContext.tsx";
import type { Session } from "@packages/core/session/session.ts";
import { useFeatureFlag } from "@squide/firefly";

export const WORKLEAP_ORGANIZATION_ID = "00b49023-7fed-4409-ba45-7c2bfa2baf08";

export const WORKLEAP_ACTION_ITEMS_MEMBER_IDS: ReadonlySet<string> = new Set([
    "54377c4f-a1d6-41fa-b95f-b65a2918f543",
    "e0a2be4c-7e53-4ddf-9676-af30101fba78",
    "81045fd5-e65f-4d05-8a75-54672f10ab6c",
    "0007960d-e3a8-4e4f-9d2c-e5df596cd710",
    "7c34a746-0e2c-4e45-a4ae-705c5585df7e",
    "b86c929b-08c0-41df-9ae5-d19645fa1b2f",
    "6d8807c8-0bf5-4e2f-836c-87569cd3efbc",
    "05d467da-5f34-4b09-a157-3d31379936f5",
    "06bb51c8-e7c2-4a14-a716-d4e591b9f2af"
]);

export function isActionItemsEnabled(isFeatureFlagEnabled: boolean, session: Session | null | undefined) {
    if (!isFeatureFlagEnabled || !session) {
        return false;
    }

    if (session.organizationId.toLowerCase() !== WORKLEAP_ORGANIZATION_ID) {
        return true;
    }

    return WORKLEAP_ACTION_ITEMS_MEMBER_IDS.has(session.memberId.toLowerCase());
}

export function useIsActionItemsEnabled() {
    const isFeatureFlagEnabled = useFeatureFlag("action-items", false);
    const session = useSession();

    return isActionItemsEnabled(isFeatureFlagEnabled, session);
}
